import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hiddenInput", "dropdown"]
  static values = { url: String }

  connect() {
    this.debounceTimer = null
    this.hideDropdownOnClickOutside = this.hideDropdownOnClickOutside.bind(this)
    document.addEventListener('click', this.hideDropdownOnClickOutside)
  }

  disconnect() {
    document.removeEventListener('click', this.hideDropdownOnClickOutside)
  }

  hideDropdownOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideDropdown()
    }
  }

  search() {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.performSearch(), 200)
  }

  async performSearch() {
    const query = this.inputTarget.value.trim()
    
    if (query.length < 1) {
      this.hideDropdown()
      return
    }

    try {
      const response = await fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`)
      if (!response.ok) throw new Error('Network error')
      
      const people = await response.json()
      this.renderDropdown(people)
    } catch (error) {
      console.error('Person search error:', error)
    }
  }

  showDropdown() {
    if (this.inputTarget.value.trim().length >= 1) {
      this.performSearch()
    }
  }

  renderDropdown(people) {
    if (people.length === 0) {
      this.dropdownTarget.innerHTML = `
        <div class="px-4 py-3 text-sm text-slate-500">No people found</div>
      `
      this.dropdownTarget.classList.remove('hidden')
      return
    }

    const html = people.slice(0, 10).map(person => `
      <button type="button" 
              class="w-full px-4 py-2 text-left hover:bg-slate-50 flex items-center gap-3"
              data-action="click->person-autocomplete#select"
              data-person-id="${person.id}"
              data-person-name="${person.name}">
        ${person.avatar_url 
          ? `<img src="${person.avatar_url}" class="w-8 h-8 rounded-full object-cover" alt="${person.name}" />`
          : `<div class="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white text-sm font-semibold">${person.name?.[0]?.toUpperCase() || '?'}</div>`
        }
        <div class="flex-1 min-w-0">
          <div class="text-sm font-medium text-slate-900 truncate">${person.name}</div>
          ${person.company ? `<div class="text-xs text-slate-500 truncate">${person.company}</div>` : ''}
        </div>
      </button>
    `).join('')

    this.dropdownTarget.innerHTML = html
    this.dropdownTarget.classList.remove('hidden')
  }

  select(event) {
    const button = event.currentTarget
    const personId = button.dataset.personId
    const personName = button.dataset.personName

    this.inputTarget.value = personName
    this.hiddenInputTarget.value = personId
    this.hideDropdown()

    // Navigate to filtered URL
    const url = new URL(window.location)
    url.searchParams.set('person_id', personId)
    window.location.href = url.toString()
  }

  clear() {
    this.inputTarget.value = ''
    this.hiddenInputTarget.value = ''
    
    // Navigate to URL without person filter
    const url = new URL(window.location)
    url.searchParams.delete('person_id')
    window.location.href = url.toString()
  }

  hideDropdown() {
    this.dropdownTarget.classList.add('hidden')
  }
}

